module.exports = __webpack_public_path__ + "static/media/photo-11.72f79212.webp";